/**
 * Typology filter keys.
 *
 * The same typology name can exist under different macro categories (e.g. "Altro"
 * belongs to both "Sport" and "Luoghi della Cultura"). To keep a selected typology
 * scoped to its parent macro category, selections are represented as composite
 * keys "macro_category::typology" instead of a bare typology string.
 *
 * A key without the separator is treated as a legacy bare typology (matched by
 * typology only) so previously saved searches keep working.
 */
export const TYPE_KEY_SEPARATOR = "::";

export function makeTypeKey(macroCategory: string, typology: string): string {
  return `${macroCategory}${TYPE_KEY_SEPARATOR}${typology}`;
}

export function parseTypeKey(key: string): { macro: string | null; typology: string } {
  const idx = key.indexOf(TYPE_KEY_SEPARATOR);
  if (idx === -1) return { macro: null, typology: key };
  return {
    macro: key.slice(0, idx),
    typology: key.slice(idx + TYPE_KEY_SEPARATOR.length),
  };
}

/** Extract just the typology label from a composite (or legacy) key. */
export function typologyOf(key: string): string {
  return parseTypeKey(key).typology;
}
